import axios from 'axios';
import apiConfig from '../../api.config';
import constants from '../../../constants';
import storage from '../../../storage';

export default function deleteHotelLicence(licence) {
  const {
    host,
    URIs: { deleteHotelLicence },
  } = apiConfig;

  const uri = `${host}${deleteHotelLicence}`.replace(':hotelLicenceId', licence.id);

  const storedCredentials = JSON.parse(storage.get(constants.AUTH.USER_KEY));

  return axios
    .delete(uri, {
      data: {
        accessToken: storedCredentials.accessToken,
        hotelReference: 'civitfun',
      }
    })
    .then(res => {
      return res.data;
    });
}
